import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import GraphQL from '../../../GraphQL';
import ShiftForm from './Form';
import SmartCard from '../../../shared/components/SmartCard';
import {
  shiftListByFilter,
  shiftMutationSave,
} from '../../../shared/queries/Shift';

const ShiftFormHandler = (props) => {
  const { match, t, history, dispatch } = props;
  const [dto, setDto] = useState({ id: 0, active: true, shiftItems: [] });
  const [formOn, setFormOn] = useState(false);

  const backClickHandler = () => {
    history.push('/minime/turno');
  };

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  function findById(id) {
    showLoading();
    const filter = {
      id,
      active: true,
      filterByStatus: false,
      updaterId: 0,
      classQuantity: 0,
    };
    const query = shiftListByFilter(filter);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.shiftListByFilter) {
          setDto({
            ...res.shiftListByFilter[0],
          });
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  }

  const handleSubmit = (values) => {
    const mutation = shiftMutationSave(values);
    showLoading();
    GraphQL(mutation, {})
      .then(() => {
        hideLoading();
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      });
  };

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  return (
    <SmartCard title={t('panels.turno')}>
      {formOn && (
        <ShiftForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          dto={dto}
          dispatch={dispatch}
        />
      )}
    </SmartCard>
  );
};

ShiftFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ShiftFormHandler)
);
